class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('#shopify-section-header');
    this.attentionBar = document.querySelector('#shopify-section-attention-bar');
    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // extra events
      this.shadow?.addEventListener('click', this.closeAll.bind(this));
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    // always open
    super.open(group);

    // level 1 code
    const level1 = !!group.dataset.collapsibleGroup.includes('level-1');
    if (level1) {
      if (this.headerWrapper) {
        this.headerWrapper.classList.add('shopify-section-header--open');
      }
      this.toggleHeaderClass(true);
    }

    // Set min height to overlay based on active level 2 item
    const target = group.querySelector(`[data-collapsible-group="level-2"].${this.options.toggleClass} [data-collapsible-target]`);
    const overlay = target?.closest('[data-overlay]');
    if (overlay) {
      overlay.style.minHeight = `${target.offsetHeight}px`;
    }
  }

  close(group, sibling) {
    const level1 = !!group.dataset.collapsibleGroup.includes('level-1');
    if (level1 && !sibling) {

      // close level 1 item
      super.close(group);
      if (this.headerWrapper) {
        this.headerWrapper.classList.remove('shopify-section-header--open');
      }
      this.toggleHeaderClass(false);

    } else if(!level1) {

      // There needs to be one active level 2 item, else close
      // Use timeout to check after open()
      setTimeout(() => {
        const siblingGroups = group.closest('[data-collapsible-target="level-1"]').querySelectorAll('[data-collapsible-group="level-2"]');
        let close = 0;
        siblingGroups.forEach((group) => {
          if (group.classList.contains(this.options.toggleClass)) {
            const level2 = !!group.dataset.collapsibleGroup.includes('level-2');
            if (level2) {
              close++;
            }
          }
        });
        if (close >= 2) {
          super.close(group);
        }
      });

    }
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
  }

  closeAll() {
    // overwrite  all default close functionality. Because only needed for level 1
    this.groups.forEach((group) => {
      const level1 = !!group.dataset.collapsibleGroup.includes('level-1');
      if (level1) {
        group.classList.remove(this.options.toggleClass);
      }
    });
    this.toggleBodyClass(false);
    this.toggleHeaderClass(false);
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      document.body.classList.add('header--is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
      this.inverse && this.header.classList.remove('header--inverse-transparent');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          const level1 = !!group.dataset.collapsibleGroup.includes('level-1');
          if (level1) {
            close = false;
          }
        }
      });
      if (close) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        document.body.classList.remove('header--is-open');
        if (this.attentionBar && scrollTop <= this.attentionBar.offsetHeight) {
          this.inverse && this.header.classList.remove('header--inverse-solid');
          this.inverse && this.header.classList.add('header--inverse-transparent');
        }
      }
    }
  }
}

class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('#shopify-section-header');
    this.attentionBar = document.querySelector('#shopify-section-attention-bar');
    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // iPhone fix
      if (navigator.platform === 'iPhone') {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      // extra events
      document.addEventListener('keyup', this.onKeyUp.bind(this));
      this.shadow?.addEventListener('click', this.remove.bind(this));
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header--is-open')) {
      return;
    }
    if(event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add('header--is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
      this.inverse && this.header.classList.remove('header--inverse-transparent');
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.add('shopify-section-header--open');
    }
    trapFocus(this.header);
  }

  remove() {
    super.remove();
    if (this.header) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.remove('header--is-open');
      if ( this.attentionBar && scrollTop <= this.attentionBar.offsetHeight) {
        this.inverse && this.header.classList.remove('header--inverse-solid');
        this.inverse && this.header.classList.add('header--inverse-transparent');
      }
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove('shopify-section-header--mobile-open');
      this.headerWrapper.classList.remove('shopify-section-header--open');
    }
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}


class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest('[data-header]');
    this.desktopSearchBox = document.querySelector('[data-header-search-desktop]');
    this.mobileSearchBox = document.querySelector('[data-header-search-take-over]');
    this.searchField = document.querySelectorAll('[data-search-input]');
    this.searchClearButton = document.querySelectorAll('[data-search-clear]');

    // options
    const { toggleClass, target } = this.options;

    // Override the inherited click behavior to prevent toggling when search input is clicked
    this.removeEventListener('click', this.reducer.click);
    this.addEventListener('click', (e) => {
      // Only toggle if the click is not on search-related elements
      if (e.target.closest('[data-search-form]') ||
          e.target.closest('[data-search-input]') ||
          e.target.closest('.search-modal__form') ||
          e.target.closest('.field')) {
        return; // Don't toggle when clicking on search elements
      }
      // Otherwise, use the inherited toggle behavior
      this.debounceClickEvent(e);
    });

    // Override the removeOnClickOutsideTarget behavior to be more specific
    if (this.options.removeOnClickOutsideTarget) {
      // Remove the default document click listener
      document.removeEventListener('click', this.reducer.click);

      // Add our own more specific click outside handler
      document.addEventListener('click', (e) => {
        if (this.target?.classList.contains(this.options.toggleClass)) {
          // Check if click is outside the search modal AND not on the toggle button itself
          const isOutsideModal = !e.target.closest(this.options.target);
          const isOnToggleButton = e.target.closest('toggle-search');

          if (isOutsideModal && !isOnToggleButton) {
            this.remove();
          }
        }
      });
    }

    // key up escape
    document.addEventListener('keyup', this.onKeyUp.bind(this));

    // custom close button
    this.closeButton = this.target?.querySelectorAll('[data-close-button]');
    this.closeButton?.forEach(button => {
      button.addEventListener('click', (e) => {
        this.preventDefault(e);
        this.stopPropagation(e);
        this.closeSearch();
        this.remove();
      });
    });

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener('click', (e) => {
      // Only handle clicks on the modal background itself, not on any child elements
      if (e.target !== this) {
        return;
      }

      document.body?.classList.remove('header--is-open');
      document.querySelector('[data-menu-drawer]')?.classList.remove('menu-drawer--is-active');
      document.querySelector('#desktopSearchInModal')?.focus();
    });

    // Toggle clear button button
    this.searchField.forEach((input) => {
      input.addEventListener('keyup', (e) => {
        const value = input.value;
        this.searchClearButton.forEach((button) => {
          if (value.length >= 1) {
            button.classList.remove('hidden');
          } else {
            button.classList.add('hidden');
          }
        });
      });
    });


    // clear search field
    this.searchClearButton.forEach((button) => {
      button.addEventListener('click', (e) => {
        this.preventDefault(e);
        this.stopPropagation(e);
        button.classList.add('hidden');
        this.searchField.forEach((input) => {
          input.value = "";
        });
        this.mobileSearchBox.dispatchEvent(new Event('input'));
      });
    });

    // Extra predictive search triggers
    if (this.options.predictiveSearch) {

      // Type inside desktop searchbox
      this.desktopSearchBox.addEventListener('keyup', (e) => {
        const value = this.desktopSearchBox.value;
        if (value.length >= 3) {
          this.mobileSearchBox.value = value;
          this.mobileSearchBox.focus();
          this.mobileSearchBox.dispatchEvent(new Event('input'));
          this.add();
        }
      });

      // Click on desktop searchbox (touchscreen)
      this.desktopSearchBox.addEventListener('focus', (e) => {
        if ([...document.querySelector('html').classList].includes('touch')) {
          setTimeout(() => {
            this.add();
          });
        }
      });

    }

  }

  onKeyUp(event) {
    if (!document.body.classList.contains('header--search-is-open')) {
      return;
    }
    if(event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      document.body.classList.add('header--search-is-open');
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      document.body.classList.remove('header--search-is-open');
    }
    if (this.options.predictiveSearch) {
      this.desktopSearchBox.value = "";
      this.mobileSearchBox.value = "";
      this.mobileSearchBox.dispatchEvent(new Event('input'));
      this.searchClearButton.forEach((button) => {
        button.classList.add('hidden');
      });
    }
    removeTrapFocus();
  }

  closeSearch() {
    const search = document.querySelector('[data-header-search]');
    const searchToggle = document.querySelector('toggle-search');

    if (!search || !searchToggle) {
      return false;
    }
    if (search.classList.contains('header__search--is-active')) {
      search.classList.remove('header__search--is-active');
      searchToggle.remove();
    }
  }

}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.header = document.querySelector('[data-header]');
    this.headerWrapper = document.querySelector('#shopify-section-header');
    this.headerElement = this;
    this.headerInverse = !!this.headerElement.classList.contains('header--inverse');
    this.headerSticky = !!this.header.classList.contains('header--sticky');
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');

    this.attention = document.querySelector('[data-attention-bar]');
    if (this.attention) {
      this.attentionWrapper = this.attention.closest('#shopify-section-attention-bar');
      this.attentionSticky = !!this.attention.classList.contains('attention-bar--sticky');
      this.attentionReveal = !!this.attention.classList.contains('attention-bar--reveal');
    }

    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('toggle-search');

    this.productInfo = document.querySelector('[data-product-info]');
    this.productSlider = document.querySelector('[data-product-media-slider]');
    this.productStickyAction = document.querySelector('[data-product-sticky-action]');

    if (this.headerWrapper) {

      this.setInitialState();
      this.setTriggerPositions();

      // scroll event
      this.raf = null; // Safe request animation frame
      this.timer = null, // Safe scroll timer
      window.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        if (!this.raf) {
          // A request animation frame is used to animate on max 60fps.
          this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
        }
        this.timer = setTimeout(() => {
          // Stop animation, cancel request animation frame
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }, 50);
      }, false);

      window.addEventListener('resize', () => {
        this.setTriggerPositions();
      });

    }
  }

  setInitialState() {
    if (this.headerSticky) {
      document.querySelector('body').classList.add('has-sticky-header');
    }
    if (this.attention && this.attentionSticky) {
      document.querySelector('body').classList.add('has-sticky-attention');
      if (!this.attentionReveal) {
        this.attentionWrapper.classList.add('attention-bar-wrapper--sticky');
      }
    }
    if (this.attention && this.attentionReveal) {
      document.querySelector('body').classList.add('has-reveal-attention');
    }
  }

  // scroll parameters
  setTriggerPositions() {
    this.currentScrollTop = 0;
    this.scrollOffset = 0;
    this.headerStart = 0;

    if (this.attention) {
      const attentionHeight = this.attentionWrapper.offsetHeight;
      this.scrollOffset += attentionHeight;
    }

    if (this.headerSticky && this.headerElement) {
      this.scrollOffset += this.headerElement.offsetHeight;
    }

  }

  scrollAnimation() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // only animate if header is closed.
    if (!document.body?.classList?.contains('header--is-open')) {
      if((scrollTop + window.innerHeight) > document.body.clientHeight) {
        this.hide();
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
        this.hide();
      } else if (scrollTop <= this.headerStart) {
        this.revealTop();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
        this.reveal();
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  hide() {
    if (this.headerSticky) {
      this.headerWrapper.classList.add('shopify-section-header--hidden', 'shopify-section-header--sticky');
    }
    if (this.attention && this.attentionReveal) {
      this.attentionWrapper.classList.add('attention-bar-wrapper--hidden', 'attention-bar-wrapper--sticky');
    }
    this.closeHeaderNav();
    this.closeMobileNav();
    this.closeSearch();
    this.productInfoPosition('up');
    this.mediaSliderPosition('up');
    this.stickyProductAction('up');
  }

  reveal() {
    if (this.headerSticky) {
      this.headerWrapper.classList.add('shopify-section-header--sticky', 'shopify-section-header--animate');
      this.headerWrapper.classList.remove('shopify-section-header--hidden');
      if (this.headerInverse) {
        this.headerElement.classList.add('header--inverse-solid');
        this.headerElement.classList.remove('header--inverse-transparent');
      }
    }
    if (this.attention && this.attentionReveal) {
      this.attentionWrapper.classList.add('attention-bar-wrapper--sticky', 'attention-bar-wrapper--animate');
      this.attentionWrapper.classList.remove('attention-bar-wrapper--hidden');
    }
    this.productInfoPosition('down');
    this.mediaSliderPosition('down');
    this.stickyProductAction('down');
  }

  revealTop() {
    if (this.headerSticky) {
      this.headerWrapper.classList.remove('shopify-section-header--hidden', 'shopify-section-header--sticky', 'shopify-section-header--animate');
      if (this.headerInverse && !document.body.classList.contains('header--is-open')) {
        this.headerElement.classList.remove('header--inverse-solid');
        this.headerElement.classList.add('header--inverse-transparent');
      }
    }
    if (this.attention && this.attentionReveal) {
      this.attentionWrapper.classList.remove('attention-bar-wrapper--hidden', 'attention-bar-wrapper--sticky', 'attention-bar-wrapper--animate');
    }
    this.productInfoPosition('up');
    this.mediaSliderPosition('up');
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if(!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.search.classList.remove('header__search--is-active');
      this.searchToggle.remove();
    }
  }

  productInfoPosition(pos = 'up') {
    if (!this.productInfo) {
      return;
    }
    if (pos == 'down') {
      this.productInfo.classList.add('product-info-col--sticky-with-header');
    } else {
      this.productInfo.classList.remove('product-info-col--sticky-with-header');
    }
  }

  mediaSliderPosition(pos = 'up') {
    if (!this.productSlider) {
      return;
    }
    if (pos == 'down') {
      this.productSlider.classList.add('product-media-slider--sticky-with-header');
    } else {
      this.productSlider.classList.remove('product-media-slider--sticky-with-header');
    }
  }

  stickyProductAction(pos = 'up') {
    if (!this.productStickyAction) {
      return;
    }
    if (pos == 'down') {
      this.productStickyAction.classList.add('product-sticky-action--offset-with-header');
    } else {
      this.productStickyAction.classList.remove('product-sticky-action--offset-with-header');
    }
  }

}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
